export const GET_WALLET_DETAILS = "GET_WALLET_DETAILS";
export const REFETCH_WALLET_DETAILS = "REFETCH_WALLET_DETAILS";
export const POLL_WALLET_DETAILS = "POLL_WALLET_DETAILS";
export const REFRESH_BALANCE = "REFRESH_BALANCE";
export const GET_ARCHIVED_ADDRESS = "GET_ARCHIVED_ADDRESS";
export const SET_ARHCIVED_ADDRESS = "SET_ARCHIVED_ADDRESS";